import {
  DEFAULT_INTERNAL_DIAGONAL_CORNER_LENGTH,
  INCH_QUOTE,
} from '~/core/constants';
import { DiagonalCornerOptions } from '~/core/enums';
import { CornerInfo } from '~/core/models';

export const addDiagonalCornerToShapeWithInternalDiagonalCorner = (
  endPt: CornerInfo
) => {
  endPt.diagonalLength = DEFAULT_INTERNAL_DIAGONAL_CORNER_LENGTH;
  endPt.label = DiagonalCornerOptions.INSIDE_CORNER;
  endPt.labelText?.set?.('text', endPt.label);
  endPt.labelMeasure?.set?.('text', `${endPt.diagonalLength}${INCH_QUOTE}`);
};
